import superagent from 'superagent'

export const featureFieldCreate = featureField => {
  return {
    type: 'FEATURE_FIELD_CREATE',
    payload: featureField
  }
}

export const featureFieldDelete = featureField => ({
  type: 'FEATURE_FIELD_DELETE',
  payload: featureField
})

export const featureFieldClear = () => ({
  type: 'FEATURE_FIELD_CLEAR'
})

export const fetchFeatureInfoFields = id => (dispatch, getState, token) => {
  const localFields = getState()['featureFields'][id]

  if (localFields && localFields.length > 0) {
    return Promise.resolve(localFields)
  }

  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/featureInfoFields/get?layerId=${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
        } else {
          let fields = res.body.filter(f => {
            if (f.fieldName) return f
          })
          dispatch(featureFieldCreate({ [id]: fields }))
          resolve(fields)
        }
      })
  })
}
